import { render, staticRenderFns } from "./FeedTankRadarChart.vue?vue&type=template&id=6ae3d019&"
import script from "./FeedTankRadarChart.vue?vue&type=script&lang=ts&"
export * from "./FeedTankRadarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports